import p from "./index2.js";
import { resolveComponent as l, openBlock as t, createElementBlock as u, normalizeClass as s, createVNode as y, withCtx as a, createElementVNode as e, toDisplayString as i, createCommentVNode as d, withModifiers as C, createBlock as f } from "vue";
import "./index3.js";
import w from "../../../../_virtual/index.js";
const h = {
  key: 0,
  class: "country-name"
}, g = ["onClick"], v = ["href"], k = { class: "country-nav-link" };
function D(o, r, I, $, M, N) {
  const c = l("DropdownMenu"), m = l("country-selector-more-dialog");
  return t(), u("div", {
    class: s(["country-nav", [
      o.showOnlyCurrentCountry ? o.variantCssClass + " hide-dropdown" : o.variantCssClass
    ]])
  }, [
    y(c, {
      class: "banner-dropdown",
      menuItems: o.showDialog ? [] : o.countryMenuItems,
      hasArrowIcon: o.hasArrow,
      type: o.dropdownMenuType,
      ref: "dropdownMenuRef"
    }, {
      title: a(() => [
        e("div", {
          class: s(["country-nav-link footer-current-country current-country", "flag flag-" + o.currentCountry.countryCode])
        }, [
          o.variant === o.countryVariants.NamedFlagWithExpansionOnClick ? (t(), u("span", h, i(o.t(`countries.${o.currentCountry.name}`)), 1)) : d("", !0)
        ], 2)
      ]),
      "country-dropdown-menu-item": a((n) => [
        e("div", {
          onClick: C((V) => o.handleCountryClick(n.menuItem.additionalInfo), ["prevent"])
        }, [
          e("a", {
            href: n.menuItem.additionalInfo.canonicalUrl,
            class: s([
              "country-nav-link",
              "flag flag-" + n.menuItem.additionalInfo.countryCode
            ])
          }, [
            e("span", null, i(o.t(`countries.${n.menuItem.additionalInfo.name}`)), 1)
          ], 10, v)
        ], 8, g)
      ]),
      "more-countries-dropdown-menu-item": a(() => [
        e("span", k, i(o.t("more")), 1),
        e("div", {
          onClick: r[0] || (r[0] = (...n) => o.openDialog && o.openDialog(...n)),
          class: "more-button"
        })
      ]),
      _: 1
    }, 8, ["menuItems", "hasArrowIcon", "type"]),
    o.showDialog ? (t(), f(m, {
      key: 0,
      showDialog: o.showDialog,
      "onUpdate:showDialog": r[1] || (r[1] = (n) => o.showDialog = n),
      countries: o.countries,
      currentCountry: o.currentCountry
    }, null, 8, ["showDialog", "countries", "currentCountry"])) : d("", !0)
  ], 2);
}
const O = /* @__PURE__ */ w(p, [["render", D], ["__scopeId", "data-v-ab0df62e"]]);
export {
  O as default
};
//# sourceMappingURL=index.js.map
